import { Popover } from 'bootstrap';

export const initPopovers = () => {
   const triggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
   return [...triggerList].map((el) => new Popover(el));
};
